<template>
  <div class="page">
    <div class="notice-bar">
      <van-notice-bar left-icon="volume-o" background="rgba(233,51,51,0.33)" color="#F3F4F5" :scrollable="false">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item,index) in spikeRolling" :key="index">
            {{`刚刚${item.contactsName}秒杀了${item.goodsName}`}}
          </van-swipe-item>
        </van-swipe>
      </van-notice-bar>
    </div>
    <div class="swipe-box" v-if="spikeGoods && spikeGoods.length" >
      <van-swipe  class="swipe" :autoplay="3000" indicator-color="#000">
        <van-swipe-item  class="swipe-item" v-for="(item, index) in spikeGoods" :key="index">
          <div class="box" @click="jumpSpikeList">
            <div class="box-left">
              <van-image width="110" height="110" radius="5" :src="item.headImg || item.headImgList[0].url" alt="" fit="cover" />
              <div class="title" v-if="item.goodsTag">{{item.goodsTag}}</div>
            </div>
            <div class="box-right">
              <div class="text">
                <span class="title" v-if="item.goodsTag">{{item.goodsTag}}</span>
                {{item.goodName}}
              </div>
              <div class="line">
                <div class="context">
                  <span>剩余100%</span>
                  <img src="https://img3.quanyou.com.cn/joy/group1/M00/16/2F/rB4ChmMbGn2AeDbJAAAIbVv5m_Y203.png" alt="">
                </div>
              </div>
              <div class="tips">总共1000个，已经有200人参与秒杀</div>
              <div class="number-box">
                <div class="yuan">
                  原价:
                  <span class="number">¥{{item.oldPrice}}</span>
                  元
                </div>
                <div class="miao">
                  秒杀价:
                  <span class="number">{{item.spikePrice > 0 ? `¥${item.spikePrice }元` : '免费'}}</span>
                </div>
                <div class="miao" v-if="boolPrePay == 'true'">
                  秒杀定金:
                  <span class="number">{{item.preSpikePrice > 0 ? `¥${item.preSpikePrice }元` : '免费'}}</span>
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="img-box" v-else>
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/18/A7/rB4ChmNRCSOAWIOyAAF4jMy80bY672.png" alt="" />
    </div>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins]
}
</script>

<style lang="stylus" scoped>
  .page {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 238px;
    margin-bottom: 10px;
    background: url('https://img3.quanyou.com.cn/joy/group1/M00/16/2F/rB4ChWMbB6SAfi4nAAKy-nx9P-E399.png');
    background-size: 100% 100%;
    .notice-bar {
      // margin-top: 10px;
      width: 100%;
      height: 20px;
      .notice-swipe {
        height: 40px;
        line-height: 40px;
      }
    }
    .swipe-box {
      margin-top: 40px;
      .swipe {
        width: 355px;
        height: 160px;
        border-radius: 10px;
        .box {
          display: flex;
          align-items: center;
          width: 340px;
          height: 140px;
          background: #FFFFFF;
          border-radius: 10px;
          padding: 8px;
          .box-left {
            position: relative;
            width: 110px;
            height:120px;
            border-radius: 5px;
            margin-right: 8px;
            .title {
              padding: 3px;
              color: #fee949;
              font-size: 10px
              position: absolute;
              bottom: 0;
              right: 0;
              border-radius: 3px;
              background: linear-gradient(180deg,rgba(252,145,165,1),rgba(252,55,92,1));
            }
          }
          .box-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            height: 94%;
            justify-content: space-between;
            .text {
              font-size: 15px;
              color: #222;
              line-height: 20px;
              .title {
                padding: 3px;
                color: #fee949;
                font-size: 10px
                border-radius: 3px;
                margin-right: 2px;
                background: linear-gradient(180deg,rgba(252,145,165,1),rgba(252,55,92,1));
              }
            }
            .line {
              width: 205px;
              height: 18px;
              background: #FFC1C1;
              border-radius: 6px;
              .context {
                position: relative;
                border-radius: 6px;
                height: 18px;
                width: 100%;
                color: #fff;
                font-size: 10px;
                line-height: 18px;
                background: #FF065E;
                span {
                  position: absolute;
                  right: 24px;
                }
                img {
                  width: 24px;
                  height: 24px;
                  right: -4px;
                  top: -3px;
                  position: absolute;
                }
              }
            }
            .tips {
              font-size: 7px;
              color: #AAADB5;
              // margin-top: 6px;
            }
            .number-box {
              // display: flex;
              // justify-content: space-between;
              // align-content: center;
              width: 96%;
              margin-top: 5px;
              font-size: 10px;
              flex-wrap: wrap;
              .yuan {
                font-size: 7px;
                .number {
                  margin-top:2px;
                  font-size: 14px;
                  color: #AAADB5;
                  text-decoration:line-through;
                }
              }
              .miao {
                color: #FD463E;
                .number {
                  color: #FD463E;
                  font-size: 14px;
                  font-weight: bold; 
                }
              }
            }
          }
        }
      }
    }
    .img-box {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow hidden;
      img {
        width: 353px;
        height: 135px;
        margin-top: 70px;
      }
    }
  }
</style>
